import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './TermosServico.css';

const TermosServico = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="termos-servico">
      {/* Header simplificado */}
      <header className="termos-header">
        <div className="container">
          <Link to="/" className="back-link">
            <i className="bi bi-arrow-left"></i> Voltar ao início
          </Link>
        </div>
      </header>

      <main className="termos-content">
        <div className="container">
          <h1>Termos de Serviço</h1>
          <p className="ultima-atualizacao">
            Última atualização: {new Date().toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' })}
          </p>

          <section className="termos-section">
            <h2>1. Introdução</h2>
            <p>
              Bem-vindo ao site da <strong>Igreja Evangélica Casa de Oração</strong>. Ao acessar e 
              utilizar este site, você concorda com os termos e condições descritos abaixo. Por favor, 
              leia-os atentamente.
            </p>
            <p>
              Nossa igreja está localizada em Hengelo, Países Baixos, e este site serve como plataforma 
              de informação e comunicação para nossa comunidade.
            </p>
          </section>

          <section className="termos-section">
            <h2>2. Uso do Site</h2>
            <p>Este site é destinado a:</p>
            <ul>
              <li>Divulgar informações sobre a Igreja Casa de Oração</li>
              <li>Informar sobre eventos, cultos e atividades</li>
              <li>Facilitar o contato com nossa comunidade</li>
              <li>Possibilitar contribuições e doações</li>
              <li>Compartilhar conteúdo espiritual e edificante</li>
            </ul>
            <p>
              Você concorda em utilizar o site apenas para fins legítimos e de acordo com estes termos.
            </p>
          </section>

          <section className="termos-section">
            <h2>3. Doações e Contribuições</h2>
            
            <h3>3.1 Natureza das Doações</h3>
            <p>
              Todas as contribuições financeiras feitas através do nosso site são <strong>doações 
              voluntárias</strong> destinadas a apoiar as atividades e ministérios da Igreja Evangélica 
              Casa de Oração.
            </p>

            <h3>3.2 Processamento de Pagamentos</h3>
            <p>
              As doações são processadas através do <strong>Tikkie</strong> (serviço do ABN AMRO Bank). 
              Ao realizar uma doação, você está sujeito também aos termos de serviço do Tikkie.
            </p>

            <h3>3.3 Uso das Doações</h3>
            <p>As doações são utilizadas para:</p>
            <ul>
              <li>Manutenção das atividades da igreja</li>
              <li>Aluguel e despesas operacionais</li>
              <li>Ações sociais e assistenciais</li>
              <li>Eventos especiais e celebrações</li>
              <li>Ministérios e projetos da igreja</li>
            </ul>
          </section>

          <section className="termos-section highlight-section">
            <h2>4. Política de Reembolso</h2>
            
            <div className="info-box importante">
              <h3><i className="bi bi-exclamation-circle"></i> Informação Importante</h3>
              <p>
                Como as doações são contribuições voluntárias para uma instituição religiosa sem fins 
                lucrativos, <strong>em regra, não são reembolsáveis</strong>.
              </p>
            </div>

            <h3>4.1 Solicitação de Reembolso</h3>
            <p>
              Em casos excepcionais (erro no valor, duplicidade de pagamento, ou outras situações 
              especiais), você pode solicitar análise de reembolso através do nosso WhatsApp:
            </p>
            
            <div className="contato-box">
              <a 
                href="https://wa.link/rntc9u" 
                target="_blank" 
                rel="noopener noreferrer"
                className="whatsapp-link"
              >
                <i className="bi bi-whatsapp"></i>
                Falar pelo WhatsApp
              </a>
              <p className="telefone">+31 6 1514 2684</p>
            </div>

            <h3>4.2 Informações Necessárias</h3>
            <p>Para análise do seu caso, tenha em mãos:</p>
            <ul>
              <li>Comprovante da doação (screenshot do Tikkie)</li>
              <li>Data e valor da transação</li>
              <li>Motivo da solicitação de reembolso</li>
              <li>Seus dados de contato</li>
            </ul>

            <h3>4.3 Prazo de Análise</h3>
            <p>
              Cada solicitação será analisada individualmente. Responderemos em até <strong>5 dias 
              úteis</strong> após o contato via WhatsApp.
            </p>

            <h3>4.4 Casos Passíveis de Reembolso</h3>
            <ul>
              <li>Erro comprovado no valor digitado</li>
              <li>Cobrança duplicada</li>
              <li>Transação não autorizada (com comprovação)</li>
            </ul>

            <h3>4.5 Casos Não Passíveis de Reembolso</h3>
            <ul>
              <li>Arrependimento após doação voluntária</li>
              <li>Doações realizadas há mais de 30 dias</li>
              <li>Falta de comprovação da transação</li>
            </ul>
          </section>

          <section className="termos-section">
            <h2>5. Eventos e Inscrições</h2>
            
            <h3>5.1 Inscrição em Eventos</h3>
            <p>
              Alguns eventos da igreja podem requerer inscrição prévia e/ou contribuição financeira. 
              As condições específicas serão informadas em cada evento.
            </p>

            <h3>5.2 Cancelamento e Reembolso de Ingressos</h3>
            
            <div className="info-box importante">
              <h4><i className="bi bi-exclamation-triangle-fill"></i> Política de Reembolso de Ingressos</h4>
              <p>
                <strong>O reembolso de ingressos é permitido APENAS nas primeiras 24 horas após a compra.</strong>
              </p>
              <p>
                <strong>Após 24 horas da compra do ingresso, NÃO haverá reembolso em nenhuma circunstância.</strong>
              </p>
            </div>

            <p>
              Para solicitar reembolso dentro do prazo de 24 horas, entre em contato pelo WhatsApp:
            </p>
            <ul>
              <li><strong>Dentro de 24h após a compra:</strong> Reembolso integral disponível</li>
              <li><strong>Após 24h da compra:</strong> Sem direito a reembolso</li>
            </ul>
            <p>
              <em>Nota: O prazo de 24 horas é contado a partir do momento da confirmação da compra do ingresso.</em>
            </p>
          </section>

          <section className="termos-section">
            <h2>6. Propriedade Intelectual</h2>
            <p>
              Todo o conteúdo deste site, incluindo textos, imagens, logotipos, vídeos e design, 
              é propriedade da Igreja Evangélica Casa de Oração ou está devidamente licenciado.
            </p>
            <p>
              É permitido compartilhar nosso conteúdo para fins não comerciais, desde que seja dado 
              o devido crédito à igreja.
            </p>
          </section>

          <section className="termos-section">
            <h2>7. Links Externos</h2>
            <p>
              Nosso site pode conter links para sites de terceiros (YouTube, Instagram, WhatsApp, 
              Tikkie). Não nos responsabilizamos pelo conteúdo ou políticas desses sites externos.
            </p>
          </section>

          <section className="termos-section">
            <h2>8. Limitação de Responsabilidade</h2>
            <p>
              A Igreja Evangélica Casa de Oração não se responsabiliza por:
            </p>
            <ul>
              <li>Interrupções temporárias no funcionamento do site</li>
              <li>Erros ou imprecisões em informações de terceiros</li>
              <li>Problemas técnicos nos serviços de pagamento</li>
              <li>Uso indevido do site por terceiros</li>
            </ul>
          </section>

          <section className="termos-section">
            <h2>9. Alterações nos Termos</h2>
            <p>
              Reservamos o direito de modificar estes Termos de Serviço a qualquer momento. 
              Alterações significativas serão comunicadas através do site. O uso continuado 
              do site após alterações constitui aceitação dos novos termos.
            </p>
          </section>

          <section className="termos-section">
            <h2>10. Lei Aplicável</h2>
            <p>
              Estes termos são regidos pelas leis dos Países Baixos. Quaisquer disputas serão 
              resolvidas preferencialmente de forma amigável e, se necessário, nos tribunais 
              competentes de Overijssel, Países Baixos.
            </p>
          </section>

          <section className="termos-section">
            <h2>11. Contato</h2>
            <p>
              Para dúvidas sobre estes Termos de Serviço ou qualquer assunto relacionado:
            </p>
            <div className="info-box">
              <p><strong>Igreja Evangélica Casa de Oração</strong></p>
              <p><i className="bi bi-geo-alt-fill"></i> Slachthuisweg 1B, Hengelo (De Rots) - Países Baixos</p>
              <p><i className="bi bi-telephone-fill"></i> +31 6 1514 2684</p>
              <p>
                <i className="bi bi-whatsapp"></i>{' '}
                <a href="https://wa.link/rntc9u" target="_blank" rel="noopener noreferrer">
                  Falar pelo WhatsApp
                </a>
              </p>
            </div>
          </section>

          <div className="termos-footer">
            <p>
              Ao utilizar nosso site e serviços, você declara ter lido e concordado com estes 
              Termos de Serviço e nossa{' '}
              <Link to="/politica-de-privacidade">Política de Privacidade</Link>.
            </p>
            <Link to="/" className="btn-voltar">
              <i className="bi bi-house-fill"></i> Voltar à Página Inicial
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default TermosServico;
